module.exports = __webpack_public_path__ + "static/media/spinner.037752c6.8fdaf29f.png";